module.exports = __webpack_public_path__ + "img/RainorView.385d47b1.png";